export const TAB = 'Tab';
export const ENTER = 'Enter';
export const ESCAPE = 'Escape';
export const SPACE = 'Space';
export const BACKSPACE = 'Backspace';
export const DELETE = 'Delete';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
